import { environment } from '@app/environments/environment';

export const MobileAppSmartBanner = () => {
    /** Kochava SmartLink - handles app installed vs not installed logic */
    const SMART_LINK_URL = environment.SMART_BANNER_URL;
    const COOKIE_NAME = 'smartBannerHide';
    const HIDE_FOR_DAYS = 30;
    const EXCLUDED_PATHS = ['/panel_bok', '/potwierdz', '/podsumowanie'];
    const APP_NAME = 'Taniej w aplikacji';
    const DESCRIPTION = 'Nawet 20% zniżki po zalogowaniu';
    const BUTTON_TEXT = 'OTWÓRZ';

    const styles = `
        .smart-banner {
            display: none;
            width: 100%;
            padding: 10px;
            background: #fff;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
            box-shadow: 0px -8px 10px 0px;
        }
        .smart-banner.is-visible {
            display: block;
        }
        .smart-banner__grid {
            display: flex;
            align-items: center;
            gap: 6px;
        }
        .smart-banner__close-btn {
            width: 30px;
            height: 40px;
            background: none;
            border: none;
            font-size: 20px;
            color: #888;
        }
        .smart-banner__app {
            display: flex;
            flex-grow: 1;
            gap: 8px;
        }
        .smart-banner__app-icon {
            width: 60px;
            height: auto;
            flex-shrink: 0;
        }
        .smart-banner__title {
            display: block;
            font-weight: bold;
            font-size: 14px;
            margin: 0 0 2px;
            line-height: 1;
        }
        .smart-banner__description {
            display: block;
            font-size: 12px;
            color: #666;
        }
        .smart-banner__cta-btn {
            background: #0050a0;
            border: none;
            border-radius: 6px;
            color: white;
            font-size: 12px;
            font-weight: 600;
            padding: 6px 12px;
        }
        @media (max-width: 380px) {
            .smart-banner {
                padding: 8px;
            }
            .smart-banner__grid {
                gap: 4px;
            }
            .smart-banner__app {
                gap: 6px;
            }
            .smart-banner__app-icon {
                width: 55px;
            }
            .smart-banner__title {
                font-size: 12px;
            }
            .smart-banner__description {
                font-size: 10px;
            }
            .smart-banner__cta-btn {
                font-size: 10px;
            }
        }
    `;

    const scripts = `
        (function() {
            const banner = document.getElementById('smart-banner');
            if (!banner) return;

            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            const ua = navigator.userAgent;
            const isWebview = /; wv\\)/.test(ua) || (/iPhone|iPad|iPod/.test(ua) && /AppleWebKit/.test(ua) && !/Safari/.test(ua));

            const isExcluded = ${JSON.stringify(EXCLUDED_PATHS)}.some(function(p) { return window.location.pathname.startsWith(p); });

            const isDismissed = document.cookie.split(';').some(function(c) { return c.trim() === '${COOKIE_NAME}=1'; });

            if (isMobile && !isWebview && !isExcluded && !isDismissed) {
                banner.classList.add('is-visible');
            }

            banner.querySelector('.js-smart-banner-close').addEventListener('click', function() {
                banner.classList.remove('is-visible');
                const expires = new Date();
                expires.setTime(expires.getTime() + (${HIDE_FOR_DAYS} * 86400000));
                document.cookie = '${COOKIE_NAME}=1;expires=' + expires.toUTCString() + ';path=/';
            });

            banner.querySelector('.js-smart-banner-cta').addEventListener('click', function() {
                const path = window.location.pathname + window.location.search;
                window.location.href = '${SMART_LINK_URL}?deeplink_url=' + encodeURIComponent(path);
            });
        })();
    `;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div id="smart-banner" className="smart-banner" suppressHydrationWarning>
                <div className="smart-banner__grid">
                    <button
                        type="button"
                        className="smart-banner__close-btn js-smart-banner-close"
                        aria-label="Zamknij"
                    >
                        ×
                    </button>
                    <div className="smart-banner__app">
                        <svg
                            className="smart-banner__app-icon"
                            viewBox="0 0 419 48"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-label={`${APP_NAME} logo`}
                        >
                            <path
                                fill="#ff3939"
                                d="M350.4 45.9c0-3 2.6-5.6 5.6-5.6 3.2 0 5.6 2.6 5.6 5.6 0 3.1-2.4 5.7-5.6 5.7C353 51.6 350.4 49 350.4 45.9z"
                            />
                            <path
                                fill="#ff3939"
                                d="M402.9 33.3c0 11.5-8.6 18.2-18.1 18.2 -2.9 0-5.2-0.3-7.3-1v13.3c-1.3 0.3-2.7 0.4-4 0.4 -1.4 0-2.7-0.1-4.1-0.4V20.7c3.3-2.7 8.7-5.3 15.2-5.3C394.9 15.4 402.9 21.5 402.9 33.3zM394.6 33.4c0-6.6-4.2-10.5-10.5-10.5 -2.4 0-4.6 0.5-6.7 1.7v18.4c1.9 0.9 4.1 1.4 6.8 1.4C390.4 44.3 394.6 40.2 394.6 33.4z"
                            />
                            <path
                                fill="#ff3939"
                                d="M410.3 50.5V3.2c1.3-0.3 2.7-0.4 4-0.4s2.8 0.1 4.2 0.4v47.2c-1.3 0.3-2.7 0.4-4.1 0.4C413.1 50.8 411.7 50.8 410.3 50.5z"
                            />
                            <path
                                fill="#0050a0"
                                d="M38.6 4.3v45.8c-2.4 0.6-5.2 0.7-7.6 0.6L9.7 20.1 8.4 17.6l0.1 2.9v30c-1.4 0.3-2.7 0.4-4 0.4 -1.3 0-2.4-0.1-4-0.4V4.7c1.7-0.6 5-1.2 7.6-0.7l21.3 30.7 1.3 2.3 -0.1-3.2V4.3c1.5-0.3 2.5-0.4 4-0.4C35.9 3.9 37.2 4 38.6 4.3z"
                            />
                            <path
                                fill="#0050a0"
                                d="M46.8 33.5c0-10.6 7.7-18.1 18.2-18.1 10.5 0 17.9 7.5 17.9 18.1 0 10.5-7.7 18.1-18.2 18.1C54.2 51.5 46.8 44.1 46.8 33.5zM74.8 33.5c0-6.6-3.7-11.1-9.9-11.1 -6.1 0-9.9 4.5-9.9 11.1 0 6.5 3.7 10.9 9.9 10.9C71 44.4 74.8 40 74.8 33.5z"
                            />
                            <path
                                fill="#0050a0"
                                d="M88.3 33.5c0-10.9 7.8-18.2 18.1-18.2 5.1 0 9.4 2 11.5 3.9 -0.6 2.3-2.2 4.5-4.4 5.8 -1.7-1.4-4-2.7-7.1-2.7 -6.7 0-9.9 5.1-9.9 11.1 0 5.8 3.1 11 9.9 11 4 0 6.1-1.7 7.6-2.9 2.1 1.1 3.6 3 4.3 5.5 -2.2 2.2-6.6 4.4-12 4.4C95.6 51.5 88.3 44.9 88.3 33.5z"
                            />
                            <path
                                fill="#0050a0"
                                d="M121.8 33.5c0-10.6 7.7-18.1 18.2-18.1 10.5 0 17.9 7.5 17.9 18.1 0 10.5-7.7 18.1-18.2 18.1C129.2 51.5 121.8 44.1 121.8 33.5zM149.7 33.5c0-6.6-3.7-11.1-9.9-11.1 -6.1 0-9.9 4.5-9.9 11.1 0 6.5 3.7 10.9 9.9 10.9C146 44.4 149.7 40 149.7 33.5z"
                            />
                            <path
                                fill="#0050a0"
                                d="M213.2 16.9c-3 12.5-7.2 24.1-12.7 33.6 -1.3 0.3-2.8 0.4-4 0.4 -1.3 0-2.6-0.1-3.9-0.4 -2.2-4-4.1-8.4-5.8-13 -1.2 4.5-3 9.1-4.9 13 -1.3 0.3-3 0.4-4.2 0.4 -1.3 0-2.7-0.1-3.9-0.4 -6.3-10.4-9.8-21-12.7-33.6 1.2-0.4 3.5-0.6 5.5-0.6 1 0 2.3 0.1 3.2 0.2 2.2 10.6 5.5 20.9 8.1 26.6l0.2 0.9c0.1-0.3 0.1-0.6 0.3-0.9 1.9-4.5 3.9-10.4 5.1-15.6 -1-3.5-1.9-7-2.7-10.6 1.2-0.4 3.5-0.6 5.5-0.6 1 0 2.1 0.1 3 0.2 2.1 10.6 4.8 20.4 7.3 26.6l0.2 1.2c0.1-0.4 0.1-0.8 0.3-1.2 3-6.9 5.5-15.8 7.7-26.6 0.9-0.1 2.2-0.2 3.2-0.2C210 16.3 211.8 16.5 213.2 16.9z"
                            />
                            <path
                                fill="#0050a0"
                                d="M246.8 29.5v18.6c-4 1.9-10 3.4-15.8 3.4 -10.1 0-15-4.2-15-11.1 0-7.1 6.1-10.9 14.4-10.8 3.2 0 6.1 0.4 8.4 1.3v-1.9c0-4.1-2.7-6.6-8.2-6.6 -4.1 0-7.6 1.6-9.5 3 -2-1-3.4-2.9-3.7-5.3 2-1.9 7.2-4.8 13.8-4.8C240.1 15.4 246.8 19.4 246.8 29.5zM231.7 45.3c2.6 0 5-0.4 7.1-1.1v-7.3c-2.2-0.9-4.9-1.4-7.8-1.4 -4 0-6.8 1.4-6.8 4.6C224.2 43.2 226.7 45.3 231.7 45.3z"
                            />
                            <path
                                fill="#0050a0"
                                d="M287.2 29.5v21c-1.4 0.3-2.8 0.4-4.1 0.4 -1.4 0-2.7-0.1-4.1-0.4v-19c0-6.3-3-8.6-8.3-8.6 -3.2 0-6 0.9-7.6 1.9v25.8c-1.3 0.3-2.7 0.4-4.1 0.4 -1.3 0-2.7-0.1-4-0.4V20.7c3-2.5 9-5.4 16.3-5.4C282.4 15.3 287.2 21.7 287.2 29.5z"
                            />
                            <path
                                fill="#0050a0"
                                d="M295 6c0-2.9 2.4-5.2 5.3-5.2 2.8 0 5.2 2.3 5.2 5.2s-2.4 5.2-5.2 5.2C297.4 11.2 295 8.9 295 6zM296.2 50.5V16.4c1.4-0.3 2.7-0.4 4.1-0.4 1.3 0 2.7 0.1 4 0.4v34.1c-1.3 0.3-2.7 0.4-4 0.4C299 50.8 297.6 50.8 296.2 50.5z"
                            />
                            <path
                                fill="#0050a0"
                                d="M344.3 35.6h-24.1c0.6 5.6 4.1 9.1 9.8 9.1 5 0 7.9-1.9 10.1-3.5 1.8 1.2 3.2 3.5 3.5 5.5 -2.9 2.3-7.3 4.8-14.2 4.8 -10.2 0-17.6-6.8-17.6-17.9 0-10.6 7.4-18.2 17.1-18.2 9.1 0 15.6 6.3 15.6 15.4C344.5 32.6 344.5 33.8 344.3 35.6zM336.5 30.2c0-4-2.1-8.1-7.6-8.2 -5 0-8.1 3.5-8.7 8.2H336.5z"
                            />
                        </svg>
                        <div className="smart-banner__app-text">
                            <span className="smart-banner__title">{APP_NAME}</span>
                            <span className="smart-banner__description">{DESCRIPTION}</span>
                        </div>
                    </div>
                    <button type="button" className="smart-banner__cta-btn js-smart-banner-cta">
                        {BUTTON_TEXT}
                    </button>
                </div>
            </div>
            <script dangerouslySetInnerHTML={{ __html: scripts }} />
        </>
    );
};
